import React from 'react';

import Slider from "rc-slider";

const RangeSteps = ({marks, changeValue, value}: { marks: any, value: any[], changeValue: (data: any, event?: React.ChangeEvent<HTMLInputElement>) => void }) => {
    const onchange = (range: any) => {
        changeValue(range)
    }
    return (
        <div className={'range-step'}>
            <Slider
                value={value}
                range
                min={0}
                max={Object.keys(marks).length -1}
                marks={marks}
                step={1}
                dots
                onChange={onchange}
            />
        </div>
    );
};

export default RangeSteps;
